import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatTableDataSource, MatPaginator, MatDialog, MatSelect } from '@angular/material';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { TranslateService } from '@ngstack/translate';
import { SubsidiaryMemorandumEntryComponent } from '../subsidiary-memorandum-entry/subsidiary-memorandum-entry.component';
import { IConfirm } from 'src/app/interfaces/confirm';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { SubsidiaryMemorandumService } from 'src/app/services/http/business/subsidiary/subsidiary-memorandum.service';
import { SubsidiaryCompanyService } from 'src/app/services/http/business/subsidiary/subsidiary-company.service';
import { CIDService } from 'src/app/services/common/cid.service';
import { ICompany } from 'src/app/interfaces/company';
import { CompanyService } from 'src/app/services/http/business/company/company.service';

@Component({
  selector: 'app-subsidiary-memorandum-list',
  templateUrl: './subsidiary-memorandum-list.component.html',
  styleUrls: ['./subsidiary-memorandum-list.component.css']
})
export class SubsidiaryMemorandumListComponent implements OnInit {
  customers = [];
  filter: any;
  showSearch: boolean = true;
  companyList: ICompany[];
  customerId: any;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    "customerTitle",
    "title",
    "agent",
    "memorandumDate",
    "status",
    "function"
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  pageSize: number;
  pageIndex: number;
  queryParams: any;
  companySelected: string;

  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private companyService: CompanyService,
    private cidService: CIDService,
    private snackBar: SnackBarService,
    private subsidiaryCompanyService: SubsidiaryCompanyService,
    public translate: TranslateService,
    private subsidiaryMemorandumService: SubsidiaryMemorandumService
  ) {
  }
  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.filter = params["params"];
      if (this.filter.CustomerId) {
        this.showSearch = false;
      }

    });
    this.getCompanyList();
    this.getCustomerList();

  }

  getCompanyList() {
    this.companyService.list(0,0).subscribe(res => {
      this.companyList = res.DataList;
      if (this.companyList.length >= 0) {
        this.getDefualtList(this.companyList[0]);
       }
    });
  }
  getDefualtList(item:any):void{
    this.cidService.setCID(item.CompanyEncryptId);
    this.companySelected=item.CompanyEncryptId;
    this.refresh();
  }
  getCustomerList() {
    this.subsidiaryCompanyService.getCustomerListCombo().subscribe(res => {
      this.customers = res;
    });
  }

  refresh() {
    this.subsidiaryMemorandumService.getUnderstandingList(this.filter).subscribe(
      res => {
        this.paginator.pageSize = 10;
        this.paginator.length = res.Total;
        this.pageIndex = 0;
        this.paginator.length = res.Total;
        this.dataSource = new MatTableDataSource(res.DataList);
      }
    );
  }

  paginatorEvent(event) {
    this.subsidiaryMemorandumService.getUnderstandingList(this.filter, event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.pageSize = event.pageSize;
        this.paginator.length = res.Total;
        this.pageIndex = event.pageIndex + 1;
        this.dataSource = new MatTableDataSource(res.DataList);
      });
  }

  setCid(e: MatSelect) {
    this.cidService.setCID(e.value);
    this.refresh();
  }

  setFilter(event: MatSelect) {
    this.filter = {
      CustomerId: event.value
    }
    this.refresh();
  }

  addMemorandum() {
    this.dialog
      .open(SubsidiaryMemorandumEntryComponent, {
        width: "750px",
        data: this.filter,
        disableClose:true
      })
      .afterClosed()
      .subscribe(() => {
        this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
      });
  }

  editMemorandum(params: any) {
    this.dialog.open(SubsidiaryMemorandumEntryComponent, {
      width: "750px",
      data: params,
      disableClose:true
    })
      .afterClosed()
      .subscribe(() => {
        this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
      });
  }

  delete(data: any): void {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.delete", {
        name: this.translate.get("label.memorandum") + " " + "'" + data.Title + "'"
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      var model: any = {
        Id: data.Id
      };
      if (result) {
        this.subsidiaryMemorandumService.understandingDelete(model).subscribe(
          () => {
            this.snackBar.OpenSnackBar(
              this.translate.get("success.deleteMemorandum"),
              "ok",
              5000,
              SoundEnum.beep
            );
            this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
          },
          () => {
            this.snackBar.OpenSnackBar(
              this.translate.get("error.deleteMemorandum"),
              "ok",
              5000,
              SoundEnum.beep
            );
            //this.errorService.transactionError();
          }
        );
      }
    });
  }

}
